export const addUnique = (target, items) => {
  const targetIds = target.map(t => t.system.id);
  items.forEach(item => {
    if (!targetIds.includes(item.system.id)) {
      target.push(item);
    }
  });
};



// WEBPACK FOOTER //
// ./src/utils/kentico-utils.js